import { DatePipe } from "@angular/common";
import { Component, Input, OnDestroy, OnInit, Output, EventEmitter } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ConfirmDialogComponent } from "app/layout/components/confirm-dialog/confirm-dialog.component";
import { AuthService } from "services/auth.service";
import { TimeOccurrenceService } from "services/corporate/timeOccurrence.service";
import { EmployeeService } from "services/corporate/employee.service";
import { PointTimeExceptionModel } from "services/models/corporate/pointTimeException.model";
import { TimeOccurrenceModel } from "services/models/corporate/timeOccurrence.model";
import { EmployeeModel } from "services/models/employee.model";
import { CreatePointTimeExceptionModalComponent } from "../create-point-exception/create-point-exception.component";
import { PointTimeExceptionService } from "services/corporate/pointTimeException.service";
import { ToastService } from "@core/components/toasts/toasts.service";
import { FileService } from "@core/services/file.service";
import { PreHandlingInfoModalComponent } from "../pre-handling-info-modal/pre-handling-info-modal.component";
import FeatureFlagEnum from "services/enums/featureFlag.enum";
import { pagesActions } from "app/page-access";
import { DomainService } from "services/domain.service";
import { QueryParams } from "services/models/odata/queryParams";

import { ExcusedAbsenceModel } from "services/models/corporate/excusedAbsence.model";
import { ExcusedAbsenceService } from "services/corporate/excusedAbsence.service";
import { ExcusedAbsenceStatusType } from "services/enums/ExcusedAbsenceStatusType.enum";
import { QualifyExcusedAbsenceModalComponent } from "../qualify-excused-absence/qualify-excused-absence.component";
import { ManageRegistrationsModalComponent } from "../manage-registrations/manage-registrations.component";
import { OccurrenceDocumentPreviewModalComponent } from "../ocurrence-document-preview/occurrence-document-preview.component";
import TimeOccurrenceParameterEnum from "services/enums/timeOccurrenceParameters.enum";
import { TimeBonusReasonModel } from "services/models/corporate/timeBonusReason.model";
import { guidEmpty, isOvertimeOccurrenceWithoutBonusReasonId } from "utils/helps";
import { ExcusedAbsenceQualificationType } from "services/enums/ExcusedAbsenceQualificationType.enum";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { CreateExcusedAbsenceModalComponent } from "../create-excused-absence/create-excused-absence.component";
import { InsightService } from "services/corporate/insight.service";
import { ComptimeEmployeeBalanceModel } from "services/models/corporate/insights/comptime-employee-balance.model";

@Component({
  selector: 'app-pre-handling-time-info-drawer',
  templateUrl: './pre-handling-time-info-drawer.component.html',
  styleUrls: ['./pre-handling-time-info-drawer.component.scss']
})

export class PreHandlingTimeInfoDrawerComponent implements OnInit, OnDestroy {

  headers = [
    "Data Ocorrência",
    "Marcações - Previsto",
    "Marcações - Realizado",
    "Ocorrência",
    "Horas",
  ];
  exceptionHeaders = [
    "EXCLUIR",
    "DATA",
    "TIPO",
    "1° ENTRADA",
    "1° SAÍDA",
    "2° ENTRADA",
    "2° SAÍDA",
  ];
  authorizeOptions = [
    { value: true, label: "SIM" },
    { value: false, label: "NÃO" },
  ];
  notAuthorizedOptions = { value: false, label: "NÃO" };
  typeLabels = {
    1: "TRABALHADO",
    2: "DSR",
  };

  @Input() employeeId: string;
  @Output() closeDrawerEvent = new EventEmitter<void>();

  employee: EmployeeModel = new EmployeeModel();
  timeOccurrences: TimeOccurrenceModel[] = [];
  managedOccurrences: TimeOccurrenceModel[] = [];
  absenceItens: TimeOccurrenceModel[] = [];
  overtimeItens: TimeOccurrenceModel[] = [];
  absencesToRequest: any[] = [];
  overtimesToRequest: any[] = [];
  isSameUser: boolean = false;
  pointTimeExceptions: PointTimeExceptionModel[] = [];
  uploadingFile: boolean = false;
  loading: boolean = false;
  isSmallScreen = false;
  canViewExcusedEvidences = this._authService.hasActionAllowed(pagesActions.employeeManagements.canViewExcusedEvidences, '/corporate/employeesmanagement');
  canChangeEvidence = this._authService.hasActionAllowed(pagesActions.employeeManagements.canChangeEvidence, '/corporate/employeesmanagement');
  canViewExceptions = this._authService.hasActionAllowed(pagesActions.employeeManagements.canViewExceptions, '/corporate/employeesmanagement');
  canViewExcusedAbsences = this._domainService.featureFlag.hasEnabled(FeatureFlagEnum.HasExcusedAbsences)
    && (this._authService.hasActionAllowed(pagesActions.employeeManagements.canViewExcusedAbsences, '/corporate/employeesmanagement')
    || this._authService.hasActionAllowed(pagesActions.employeeManagements.canCreateOwnAbsences, '/corporate/employeesmanagement')
    || this._domainService.getDomain().timeOccurrenceParameters.anyoneCanCreateOwnExcusedAbsence);
  canCreateOwnExcusedAbsence = this._domainService.featureFlag.hasEnabled(FeatureFlagEnum.HasExcusedAbsences)
    && (this._authService.hasActionAllowed(pagesActions.employeeManagements.canCreateOwnAbsences, '/corporate/employeesmanagement')
    || this._domainService.getDomain().timeOccurrenceParameters.anyoneCanCreateOwnExcusedAbsence);
  canQualifyExcusedAbsences = this._domainService.featureFlag.hasEnabled(FeatureFlagEnum.HasExcusedAbsences)
    && this._authService.hasActionAllowed(pagesActions.employeeManagements.canQualifyExcusedAbsences, '/corporate/employeesmanagement');
  showComptimeBalance = this._domainService.featureFlag.hasEnabled(FeatureFlagEnum.UsesComptimeEmployeeBalance);
  comptimeBalance: ComptimeEmployeeBalanceModel | null = null;
  loadingComptimeBalance = false;
  timeOccurrenceParameters = this._domainService.getDomain().timeOccurrenceParameters;
  usesOvertimeJustification = this._domainService.timeOccurrenceParameters.hasEnabled(TimeOccurrenceParameterEnum.EnableOvertimeJustification);
  usesOvertimeApprovalReason = this._domainService.timeOccurrenceParameters.hasEnabled(TimeOccurrenceParameterEnum.EnableOvertimeApprovalReason);
  usesPreAbono = this._domainService.timeOccurrenceParameters.hasEnabled(TimeOccurrenceParameterEnum.EnablePreAbono);
  disabledPointTimeException = this._domainService.timeOccurrenceParameters.hasEnabled(TimeOccurrenceParameterEnum.DisablePointTimeException);
  canViewOvertimes = this._authService.hasActionAllowed(pagesActions.employeeManagements.canViewOvertimes, '/corporate/employeesmanagement');
  excusedAbsences: ExcusedAbsenceModel[] = [];
  excusedAbsenceStatusOptions = ExcusedAbsenceStatusType.buildListEnum();
  loadingOccurrences = false;
  loadingExcused = false;
  loadingManagedOccurrences = false;
  useClosedPeriodsHistory: boolean = false;
  filterText: string = "";
  filteredBonusReasons: TimeBonusReasonModel[] = [];

  private readonly destroy$ = new Subject<void>();
  private readonly onWindowResize = (): void => {
    this.isSmallScreen = window.innerWidth < 768;
  };

  queryParams: QueryParams;
  closeDrawer() {
    this.closeDrawerEvent.emit();
  }
  constructor(
    private _modalService: NgbModal,
    private toast: ToastService,
    private _employeeService: EmployeeService,
    private _authService: AuthService,
    private _datePipe: DatePipe,
    private _service: TimeOccurrenceService,
    private _pointTimeExceptionService: PointTimeExceptionService,
    private _fileService: FileService,
    private _domainService: DomainService,
    public service: ExcusedAbsenceService,
    private _insightService: InsightService,
  ) { }

  ngOnInit(): void {
    this.getEmployee();
    this.loadComptimeBalance();
    this.listPendingOccurences();
    this.verifySameUser();
    this.isSmallScreen = window.innerWidth < 768;
    window.addEventListener("resize", this.onWindowResize);
  }

  ngOnDestroy(): void {
    window.removeEventListener("resize", this.onWindowResize);
    this.destroy$.next();
    this.destroy$.complete();
  }

  openModal(item: TimeOccurrenceModel): void {
    const modalRef = this._modalService.open(PreHandlingInfoModalComponent, {
      centered: false,
      keyboard: false,
      backdrop: "static",
      size: "md",
      windowClass: "pht-modal",
      backdropClass: "pht-modal-backdrop",
    });

    modalRef.componentInstance.title = "Tratamento de ponto";
    modalRef.componentInstance.content =
      item?.subType === "OVERTIME"
        ? "Selecione a justificativa para a hora extra."
        : "Selecione a justificativa para a ausência.";
    modalRef.componentInstance.item = item;
    modalRef.componentInstance.usesOvertimeJustification = this.usesOvertimeJustification;
  }

  setBonusReasonOptions(item: TimeOccurrenceModel): void {
    this.filterText = "";

    const bonusReasonOptions = item?.allowedBonusReasons ?? [];
    if (!bonusReasonOptions.length) {
      return;
    }

    if (item.subType === "OVERTIME") {
      this.filteredBonusReasons = [
        {
          order: 0,
          title: this.notAuthorizedOptions.label,
          id: guidEmpty,
        } as TimeBonusReasonModel,
      ].concat(bonusReasonOptions);
      return;
    }

    this.filteredBonusReasons = bonusReasonOptions;
  }

  listExcused() {
    this.loadingExcused = true;
    const params = new QueryParams();

    this.service.listAbsencesByEmployee(params, this.employeeId).pipe(takeUntil(this.destroy$)).subscribe(
      (res) => {
        this.excusedAbsences = res.data.sort((a, b) =>
          new Date(b.creationDate).getTime() - new Date(a.creationDate).getTime()
        );
        this.loadingExcused = false;
      },
      () => {
        this.loadingExcused = false;
      }
    );
  }

  openExcusedAbsenceInfo(excusedAbsence: ExcusedAbsenceModel) {
    const canQualify = this.canQualifyExcusedAbsences;
    const modalRef = this._modalService.open(QualifyExcusedAbsenceModalComponent, {
      centered: true,
      keyboard: false,
      size: canQualify ? 'xl' : 'lg',
      windowClass: "phs-modal",
      backdropClass: "phs-modal-backdrop"
    });
    modalRef.componentInstance.excusedAbsenceId = excusedAbsence.id;
    modalRef.componentInstance.companyId = excusedAbsence.companyId;
    modalRef.componentInstance.icdClassificationDescription = excusedAbsence.icdClassificationDescription;
    modalRef.componentInstance.documentOnlyView = !canQualify;
    modalRef.componentInstance.onlyView = !canQualify || excusedAbsence.status !== 'PENDING';
    modalRef.closed.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.listExcused();
      this.listPendingOccurences();
    });
  }

  getExcusedAbsenceActionLabel(item: ExcusedAbsenceModel): string {
    if (!this.canQualifyExcusedAbsences) {
      return 'Visualizar Documento';
    }
    return item.status !== 'PENDING' ? 'Visualizar Qualificação' : 'Qualificar Ausência';
  }

  getExcusedAbsenceActionClass(item: ExcusedAbsenceModel): string {
    if (!this.canQualifyExcusedAbsences) {
      return 'btn-outline-secondary';
    }
    return item.status !== 'PENDING' ? 'btn-outline-success' : 'btn-outline-primary';
  }

  openCreateExcusedAbsence() {
    if (!this.excusedAbsences.length) {
      this.listExcused();
    }

    const modalRef = this._modalService.open(CreateExcusedAbsenceModalComponent, {
      centered: true,
      keyboard: false,
      backdrop: 'static',
      size: 'md',
      windowClass: 'phs-modal',
      backdropClass: 'phs-modal-backdrop',
    });
    modalRef.componentInstance.employee = this.employee;
    modalRef.componentInstance.parameters = this.timeOccurrenceParameters;
    modalRef.componentInstance.existingAbsences = this.excusedAbsences;
    modalRef.closed.pipe(takeUntil(this.destroy$)).subscribe((submit) => {
      if (submit) {
        this.listExcused();
      }
    });
  }

  openDocumentPreview(occurrence: TimeOccurrenceModel) {
    const modalRef = this._modalService.open(OccurrenceDocumentPreviewModalComponent, {
      centered: true,
      keyboard: false,
      windowClass: "phs-modal",
      backdropClass: "phs-modal-backdrop"
    });
    modalRef.componentInstance.timeOccurrenceId = occurrence.id;
    modalRef.closed.pipe(takeUntil(this.destroy$)).subscribe((submit) => {
      if (submit === false) return;
      this.listPendingOccurences();
    });
  }

  listPendingOccurences() {
    this.loadingOccurrences = true;
    this._service.listPendingOccurrencesByEmployee(this.employeeId).pipe(takeUntil(this.destroy$)).subscribe(
      (res) => {
        this.timeOccurrences = res.data.filter(
          (x) => x.day != this.todayFormatedDate()
        );
        this.setAbsencesAndOvertimeItens();
        this.sortAllowedBonusReasons(this.absenceItens);
        this.sortAllowedBonusReasons(this.overtimeItens);

        this.sortOccurrencesByDay(this.absenceItens);
        this.sortOccurrencesByDay(this.overtimeItens);
        this.loadingOccurrences = false;
      },
      () => {
        this.loadingOccurrences = false;
      }
    );
  }


  getEmployee() {
    this._employeeService.get(this.employeeId).pipe(takeUntil(this.destroy$)).subscribe((res) => {
      this.employee = res.data;
    });
  }

  get comptimeBalanceLabel(): string {
    if (this.comptimeBalance == null) {
      return "—";
    }

    return `${this.comptimeBalance.balance}h`;
  }

  private loadComptimeBalance(): void {
    if (!this.showComptimeBalance || !this.employeeId) {
      return;
    }

    this.loadingComptimeBalance = true;
    this._insightService
      .getComptimeEmployeeBalance(this.employeeId)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          this.comptimeBalance = res.data;
          this.loadingComptimeBalance = false;
        },
        () => {
          this.comptimeBalance = null;
          this.loadingComptimeBalance = false;
        }
      );
  }

  todayFormatedDate() {
    let today = new Date(),
      month = "" + (today.getMonth() + 1),
      day = "" + today.getDate(),
      year = today.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }

  setAbsencesAndOvertimeItens() {
    this.absenceItens = this.timeOccurrences.filter(
      (x) => x.subType == "ABSENCE"
    );
    this.overtimeItens = this.timeOccurrences.filter(
      (x) => x.subType == "OVERTIME"
    );
  }

  prepareAbsenceRequests() {
    this.clearOccurrencesToRequest();

    const expiredDocItem = this.absenceItens.find(
      (item) =>
        !!item.bonusReasonId &&
        !!this.getBonusReason(item, item.bonusReasonId)?.requiresDocument &&
        !item.fileKey &&
        this.isDocumentUploadPastDeadline(item)
    );
    if (expiredDocItem) {
      this.toast.showWarning(
        this.buildDocumentDeadlineExceededMessage(expiredDocItem),
        "top-center"
      );
      return false;
    }

    const requiresDocumentWithoutFile = this.absenceItens.some(
      (item) =>
        item.bonusReasonId &&
        this.getBonusReason(item, item.bonusReasonId)?.requiresDocument &&
        !item.fileKey
    );

    if (requiresDocumentWithoutFile) {
      this.toast.showWarning(
        "Selecione um arquivo para justificar a ocorrência.",
        "top-center"
      );
      return false;
    }

    this.absencesToRequest = this.absenceItens
      .filter((item) => !!item.bonusReasonId)
      .map((item) => ({
        bonusReasonId: item.bonusReasonId,
        timeOccurrenceId: item.id,
        fileKey: item.fileKey,
        fileName: item.fileName,
      }));

    return true;
  }

  hasOddValidRegistrations(occurrence): boolean {
    const registrations = this.hasAnyModifiedTime(occurrence)
      ? [
        occurrence.modifiedEntry1, occurrence.modifiedDeparture1,
        occurrence.modifiedEntry2, occurrence.modifiedDeparture2,
        occurrence.modifiedEntry3, occurrence.modifiedDeparture3,
        occurrence.modifiedEntry4, occurrence.modifiedDeparture4,
      ]
      : [
        occurrence.realEntry1, occurrence.realDeparture1,
        occurrence.realEntry2, occurrence.realDeparture2,
        occurrence.realEntry3, occurrence.realDeparture3,
        occurrence.realEntry4, occurrence.realDeparture4,
      ];

    const validCount = this.countValidRegistrations(registrations);
    return validCount % 2 !== 0;
  }

  private sortAllowedBonusReasons(occurrences: TimeOccurrenceModel[]) {
    occurrences.forEach((occurrence) => {
      this.sortBonusReasons(occurrence.allowedBonusReasons);
    });
  }

  countValidRegistrations(registrations: (string | null)[]): number {
    if (!registrations) return 0;

    return registrations.filter(time => time && time !== "00:00:59").length;
  }

  setOvertimesToRequest() {
    this.clearOccurrencesToRequest();

    this.overtimeItens
      .filter((item) => item.authorized != null)
      .forEach((item) => {
        const authorize = item.authorized === true;
        let bonusReasonId: string | null | undefined;
        if (this.usesOvertimeJustification) {
          bonusReasonId =
            authorize && item.bonusReasonId && item.bonusReasonId !== guidEmpty
              ? item.bonusReasonId
              : null;
        } else {
          bonusReasonId = undefined;
        }

        this.overtimesToRequest.push({
          timeOccurrenceId: item.id,
          authorize,
          bonusReasonId,
          overtimeApprovalReason: this.usesOvertimeApprovalReason
            ? this.normalizeOvertimeApprovalReason(item.overtimeApprovalReason)
            : null,
        });
      });
  }

  listManagedOccurrences() {
    this.loadingManagedOccurrences = true;
    this._service
      .listManagedOccurrencesByEmployee(this.employeeId, this.useClosedPeriodsHistory)
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        this.managedOccurrences = res.data;
        this.sortOccurrencesByDay(this.managedOccurrences);
        this.loadingManagedOccurrences = false;
      }, () => {
        this.loadingManagedOccurrences = false;
      });
  }

  setHistoryPeriod(useClosedPeriods: boolean): void {
    if (this.useClosedPeriodsHistory === useClosedPeriods) {
      return;
    }

    this.useClosedPeriodsHistory = useClosedPeriods;
    this.listManagedOccurrences();
  }

  syncOccurrences() {
    this._service.syncOccurrencesByEmployee(this.employeeId).pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.toast.showSuccess("Ocorrências sincronizadas com sucesso!");
      this.listPendingOccurences();
    },
      (err) => { }
    );
  }

  listPointTimeExceptions() {
    this._pointTimeExceptionService
      .listPointTimeExceptionsByEmployee(this.employeeId)
      .pipe(takeUntil(this.destroy$))
      .subscribe((x) => {
        this.pointTimeExceptions = x.data;
        this.sortPointTimeExceptions(this.pointTimeExceptions);
      });
  }

  removePointTimeException(pointTimeException: PointTimeExceptionModel) {
    const modalRef = this._modalService.open(ConfirmDialogComponent, {
      size: 'md',
      windowClass: 'phs-modal',
      backdropClass: 'phs-modal-backdrop',
    });

    modalRef.componentInstance.message = `Deseja realmente excluir a exceção de ponto da data 
      ${this.formatDate(
      pointTimeException.date
    )}? Clique em confirmar para continuar com a exclusão.`;
    modalRef.componentInstance.focusConfirm = true;
    modalRef.closed.pipe(takeUntil(this.destroy$)).subscribe((submit) => {
      if (submit) {
        this._pointTimeExceptionService
          .remove(pointTimeException.id)
          .pipe(takeUntil(this.destroy$))
          .subscribe(() => {
            this.toast.showSuccess("Exceção de ponto removida com sucesso!");
            this.listPointTimeExceptions();
          });
      }
    });
  }

  openCreatePointTimeException() {
    const modalRef = this._modalService.open(
      CreatePointTimeExceptionModalComponent, {
      size: 'md',
      windowClass: 'phs-modal',
      backdropClass: 'phs-modal-backdrop',
    });
    modalRef.componentInstance.employee = this.employee;
    modalRef.componentInstance.parameters = this.timeOccurrenceParameters;
    modalRef.closed.pipe(takeUntil(this.destroy$)).subscribe((submit) => {
      if (submit) {
        this.listPointTimeExceptions();
      }
    });
  }

  formatDate(date: any) {
    const toDate = new Date(date);
    return this._datePipe.transform(
      toDate.setDate(toDate.getDate() + 1),
      "dd/MM/yyyy"
    );
  }

  sortOccurrencesByDay(array: any) {
    array.sort((a, b) => {
      if (a.day > b.day) {
        return 1;
      }
      if (a.day < b.day) {
        return -1;
      }
      return 0;
    });
  }

  sortBonusReasons(array: any) {
    array.sort((a, b) => {
      if (a.order > b.order) {
        return 1;
      }
      if (a.order < b.order) {
        return -1;
      }
      return 0;
    });
  }

  clearOccurrencesToRequest() {
    this.absencesToRequest = [];
    this.overtimesToRequest = [];
  }

  paidAbsences() {
    if (!this.prepareAbsenceRequests()) {
      return;
    }

    if (!this.hasAbsencesToRequest()) {
      this.toast.showWarning(
        "Selecione justificativa nas ocorrências para tratar."
      );
      return;
    }

    const modalRef = this._modalService.open(ConfirmDialogComponent, {
      windowClass: 'confirm-dialog-modal',
      backdropClass: 'confirm-dialog-backdrop'
    });
    modalRef.componentInstance.message = `Deseja realmente ${this.isSameUser ? "pré-aprovar" : "aprovar"
      } 
        ${this.absencesToRequest.length} ocorrência(s) de ausências pendentes?`;
    modalRef.componentInstance.focusConfirm = true;
    modalRef.closed.pipe(takeUntil(this.destroy$)).subscribe((submit) => {
      if (submit) {
        this._service.accreditTimeOccurrence(this.absencesToRequest).pipe(takeUntil(this.destroy$)).subscribe(
          () => {
            this.clearOccurrencesToRequest();
            this.toast.showSuccess(
              "Pendências atualizadas com sucesso!",
              "top-right"
            );
            this.listPendingOccurences();
          },
          (err) => { }
        );
      }
    });
  }

  authorizeOvertimes() {
    this.setOvertimesToRequest();
    if (this.hasOvertimesToRequest()) {
      const modalRef = this._modalService.open(ConfirmDialogComponent, {
        windowClass: 'confirm-dialog-modal',
        backdropClass: 'confirm-dialog-backdrop'
      });
      modalRef.componentInstance.message = this.usesOvertimeJustification
        ? `Deseja realmente ${this.isSameUser ? "pré-aprovar" : "aprovar"
        } ${this.overtimesToRequest.length} ocorrência(s) de horas extras pendentes?`
        : `Deseja realmente ${this.isSameUser ? "pré-autorizar" : "autorizar"
        } ${this.overtimesToRequest.filter((x) => x.authorize === true).length} ocorrência(s)
        / não autorizar ${this.overtimesToRequest.filter(
          (x) => x.authorize === false
        ).length} ocorrência(s) de horas extras pendentes?`;
      modalRef.componentInstance.focusConfirm = true;
      modalRef.closed.pipe(takeUntil(this.destroy$)).subscribe((submit) => {
        if (submit) {
          this._service.authorizeTimeOccurrence(this.overtimesToRequest).pipe(takeUntil(this.destroy$)).subscribe(
            () => {
              this.clearOccurrencesToRequest();
              this.toast.showSuccess(
                "Pendências atualizadas com sucesso!"
              );
              this.listPendingOccurences();
            },
            (err) => {
              this.clearOccurrencesToRequest();
              this.listPendingOccurences();
            }
          );
        }
      });
    } else {
      this.toast.showWarning(
        this.usesOvertimeJustification
          ? "Selecione justificativa nas ocorrências para tratar."
          : "Selecione autorização nas ocorrências para tratar."
      );
    }
  }

  getSelectedBonusReasonTitle(timeOccurrence: TimeOccurrenceModel): string {
    const selectedBonusReason = timeOccurrence.allowedBonusReasons.find(
      (x) => x.id === timeOccurrence.bonusReasonId
    );
    if (selectedBonusReason) {
      return selectedBonusReason.title;
    }
    if (isOvertimeOccurrenceWithoutBonusReasonId(this.usesOvertimeJustification, timeOccurrence)) {
      return this.getAuthorizedLabel(timeOccurrence.authorized);
    }
    return "";
  }

  bonusReasonDescriptionTooltip(description: string | undefined | null): string | null {
    const trimmed = description?.trim();
    return trimmed ? trimmed : null;
  }

  getSelectedBonusReasonDescription(timeOccurrence: TimeOccurrenceModel): string | null {
    const selected = timeOccurrence.allowedBonusReasons?.find(
      (x) => x.id === timeOccurrence.bonusReasonId
    );
    return selected ? this.bonusReasonDescriptionTooltip(selected.description) : null;
  }

  verifySameUser() {
    this._employeeService
      .get(this._authService.getUserId())
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        this.isSameUser = res.data.id == this.employeeId;
      });
  }

  sortPointTimeExceptions(array: any) {
    array.sort((a, b) => {
      if (a.date > b.date) {
        return 1;
      }
      if (a.date < b.date) {
        return -1;
      }
      return 0;
    });
  }

  hasOvertimesToRequest(): boolean {
    if (!this.usesOvertimeJustification) {
      return this.overtimeItens.some((item) => item.authorized != null);
    }
    return this.overtimeItens.some(
      (item) =>
        item.bonusReasonId != null &&
        item.bonusReasonId !== '' &&
        item.authorized != null
    );
  }

  hasAbsencesToRequest(): boolean {
    return this.absenceItens.filter((x) => x.bonusReasonId != null).length > 0;
  }

  getTypeLabel(type: number): string {
    return this.typeLabels[type] || "TRABALHADO";
  }

  getAuthorizedLabel(authorized: boolean | undefined): string {
    return authorized == null ? "" : authorized ? "SIM" : "NÃO";
  }

  formatToHourAndMinutes(time: string): string {
    return time.localeCompare("00:00:59") == 0 ? "-" : time.slice(0, -3);
  }

  onBonusReasonChange(selectedValue: string, timeOccurrence: TimeOccurrenceModel) {
    const bonusReason = this.getBonusReason(timeOccurrence, selectedValue);
    const foundItem =
      this.absenceItens.find((x) => x.id === timeOccurrence.id) ??
      this.overtimeItens.find((x) => x.id === timeOccurrence.id);

    if (!foundItem) {
      return;
    }

    if (foundItem.subType === 'OVERTIME' && this.usesOvertimeJustification) {
      foundItem.bonusReasonId = selectedValue === guidEmpty ? guidEmpty : bonusReason ? bonusReason.id : '';
      foundItem.authorized = selectedValue != null && selectedValue !== guidEmpty;
      return;
    }

    foundItem.bonusReasonId = bonusReason ? bonusReason.id : '';
  }

  handleFileInput(event: Event, occurrence: TimeOccurrenceModel) {
    const input = event.target as HTMLInputElement;
    if (this.disabledUploadButton(occurrence)) {
      input.value = "";
      return;
    }
    if (!input.files?.length) return;

    const file = input.files[0];
    const allowedExtensions = ["pdf", "xlsx", "doc", "docx", "png", "jpg", "jpeg"];

    const fileName = file.name;
    const extension = fileName.substring(fileName.lastIndexOf(".") + 1).toLowerCase();

    if (!allowedExtensions.includes(extension)) {
      this.toast.showWarning(
        "O formato do arquivo inserido não é permitido."
      );
      return;
    }

    const reader = new FileReader();
    reader.onloadend = () => {
      const encodedBase64 = reader.result as string;
      const base64String = encodedBase64.split("base64,")[1];
      occurrence.fileContent = {
        encodedBase64: base64String,
        fileName: fileName,
        extension,
      };
      this.uploadTempFile(occurrence);
    };

    reader.readAsDataURL(file);
  }

  uploadTempFile(occurrence: TimeOccurrenceModel) {
    this.uploadingFile = true;
    this._service.uploadTempFile(occurrence).pipe(takeUntil(this.destroy$)).subscribe((res) => {
      this.uploadingFile = false;
      occurrence.fileKey = res.data.fileKey;
      occurrence.fileName = res.data.fileName;
    });
  }

  popoverTitle(timeOccurrence: TimeOccurrenceModel) {
    return this.shouldRequireDocumentForBonusReason(timeOccurrence)
      ? "Selecionar Documento"
      : "";
  }

  popoverDescription(timeOccurrence: TimeOccurrenceModel) {
    return this.shouldRequireDocumentForBonusReason(timeOccurrence)
      ? 'Permitido apenas arquivos nos formatos: "PDF", "DOC", "DOCX", "DOCM", "PNG", "JPG", "JPEG"'
      : "Documento não obrigatório";
  }

  private shouldRequireDocumentForBonusReason(
    timeOccurrence: TimeOccurrenceModel
  ) {
    const item = this.getBonusReason(
      timeOccurrence,
      timeOccurrence.bonusReasonId
    );
    return item && item.requiresDocument;
  }

  iconColor(timeOccurrence: TimeOccurrenceModel) {
    const bonusReason = this.getBonusReason(
      timeOccurrence,
      timeOccurrence.bonusReasonId
    );

    if (!bonusReason || !bonusReason.requiresDocument) {
      return "";
    }

    if (!timeOccurrence.fileKey && !bonusReason.requiresDocument) {
      return "text-primary";
    } else if (!timeOccurrence.fileKey && bonusReason.requiresDocument) {
      return "text-danger";
    } else if (timeOccurrence.fileKey && bonusReason.requiresDocument) {
      return "text-success";
    }

    return "";
  }

  getBonusReason(timeOccurrence: TimeOccurrenceModel, bonusReasonId: string) {
    return timeOccurrence.allowedBonusReasons.find(
      (x) => x.id === bonusReasonId
    );
  }

  applyDocument(timeOccurrence: TimeOccurrenceModel) {
    const index = this.absenceItens.findIndex(
      (x) => x.id === timeOccurrence.id
    );

    if (index > 0) {
      const previousItem = this.absenceItens[index - 1];
      timeOccurrence.fileKey = previousItem.fileKey;
      timeOccurrence.fileName = previousItem.fileName;
    }
  }

  showIconRepeatDocument(timeOccurrence: TimeOccurrenceModel) {
    if (!timeOccurrence.bonusReasonId) return false;

    if (timeOccurrence.fileKey) return false;

    const filter = this.absenceItens.find(
      (x) => x.bonusReasonId === timeOccurrence.bonusReasonId
    );
    if (!filter) return false;

    if (filter.fileKey) {
      return true;
    } else {
      return false;
    }
  }

  documentUploadUiState(timeOccurrence: TimeOccurrenceModel): {
    disabled: boolean;
    deadlineHint: string | null;
    tooltip: string | null;
  } {
    const bonusReason = this.getBonusReason(timeOccurrence, timeOccurrence.bonusReasonId);
    const requiresDoc = !!bonusReason?.requiresDocument;
    const pastDeadline = requiresDoc && this.isDocumentUploadPastDeadline(timeOccurrence);
    const disabled = !requiresDoc || pastDeadline;

    const deadlineHint = pastDeadline ? this.buildDocumentDeadlineExceededMessage(timeOccurrence) : null;
    const tooltip = disabled ? (deadlineHint ?? "Selecione uma justificativa que exija documento para enviar o arquivo.") : null;

    return { disabled, deadlineHint, tooltip };
  }

  disabledUploadButton(timeOccurrence: TimeOccurrenceModel): boolean {
    return this.documentUploadUiState(timeOccurrence).disabled;
  }

  private getMaxDaysForDocumentUploadAfterOccurrence(): number {
    const raw = Number(this.timeOccurrenceParameters?.daysToSendDocumentBeforeOccurrence ?? 0);
    if (!Number.isFinite(raw) || raw <= 0) {
      return 0;
    }
    return Math.floor(raw);
  }

  private parseOccurrenceLocalDate(day: string): Date | null {
    if (!day) {
      return null;
    }
    const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(day.trim());
    if (!match) {
      return null;
    }
    const y = Number(match[1]);
    const m = Number(match[2]);
    const d = Number(match[3]);
    const dt = new Date(y, m - 1, d);
    return Number.isNaN(dt.getTime()) ? null : dt;
  }

  isDocumentUploadPastDeadline(timeOccurrence: TimeOccurrenceModel): boolean {
    const maxDays = this.getMaxDaysForDocumentUploadAfterOccurrence();
    if (maxDays <= 0 || !this.shouldRequireDocumentForBonusReason(timeOccurrence)) {
      return false;
    }

    const occurrenceDate = this.parseOccurrenceLocalDate(timeOccurrence.day);
    if (!occurrenceDate) {
      return false;
    }

    const deadline = new Date(occurrenceDate);
    deadline.setDate(deadline.getDate() + maxDays);

    const today = new Date();
    const todayStart = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    const deadlineStart = new Date(deadline.getFullYear(), deadline.getMonth(), deadline.getDate());
    return todayStart > deadlineStart;
  }

  private buildDocumentDeadlineExceededMessage(timeOccurrence: TimeOccurrenceModel): string {
    const maxDays = this.getMaxDaysForDocumentUploadAfterOccurrence();
    const label = this.formatOccurrenceDayLabel(timeOccurrence.day);
    return `Não é mais permitido enviar comprovante para a ausência de ${label}: o prazo de ${maxDays} dia(s) após a ocorrência já foi ultrapassado.`;
  }

  private formatOccurrenceDayLabel(day: string): string {
    const parsed = this.parseOccurrenceLocalDate(day);
    if (!parsed) {
      return day;
    }
    return this._datePipe.transform(parsed, "dd/MM/yyyy") ?? day;
  }

  showDownloadDocumentAction(timeOccurrence: TimeOccurrenceModel): boolean {
    // if (this.isSameUser) return false;

    const bonusReason = this.getBonusReason(
      timeOccurrence,
      timeOccurrence.bonusReasonId
    );
    if (!bonusReason) return false;

    return (
      bonusReason.requiresDocument &&
      !!timeOccurrence.pendingApproval &&
      !!timeOccurrence.fileKey
    );
  }

  downloadDocument(timeOccurrence: TimeOccurrenceModel, tempFile: boolean) {
    this._service.getFile(timeOccurrence.id, tempFile).pipe(takeUntil(this.destroy$)).subscribe(
      (data: any) => {
        const { fileContents, contentType, fileDownloadName } = data.body;
        this._fileService.downloadBase64File(
          fileContents,
          contentType,
          fileDownloadName
        );
        this.toast.showSuccess(
          "Download do arquivo realizado com sucesso!",
          "top-right"
        );
      },
      (error) => {
        this.toast.showWarning(
          "Falha ao realizar download do arquivo!",
          "top-right"
        );
      }
    );
  }

  selectBonusReason(bonusReasonId: string, item: any) {
    item.bonusReasonId = bonusReasonId;
    this.onBonusReasonChange(bonusReasonId, item);
  }

  getSelectedAuthorizeLabel(value: boolean | undefined): string | null {
    const selected = this.authorizeOptions.find(opt => opt.value === value);
    return selected ? selected.label : null;
  }

  selectAuthorizeOption(value: boolean, item: any): void {
    item.authorized = value;
  }

  get showDocumentInAbsences(): boolean {
    return (
      this.absenceItens?.[0]?.allowedBonusReasons?.some(
        (reason) => reason.requiresDocument === true
      ) ?? false
    );
  }

  showManageRegistrationsInAbsences(timeOccurrence: TimeOccurrenceModel): boolean {
    const bonusReason = this.getBonusReason(
      timeOccurrence,
      timeOccurrence.bonusReasonId
    );

    if (!bonusReason) {
      return false;
    }

    if (bonusReason.canApproveWithOddRegistrations) {
      return false;
    } else {
      return true;
    }
  }

  hasAnyModifiedTime(timeOccurrence: any): boolean {
    const modifiedTimes = [
      timeOccurrence.modifiedEntry1, timeOccurrence.modifiedDeparture1,
      timeOccurrence.modifiedEntry2, timeOccurrence.modifiedDeparture2,
      timeOccurrence.modifiedEntry3, timeOccurrence.modifiedDeparture3,
      timeOccurrence.modifiedEntry4, timeOccurrence.modifiedDeparture4
    ];

    return modifiedTimes.some(time => time !== null);
  }

  isModified(timeOccurrence, time): boolean {
    const realTimes = [
      timeOccurrence.realEntry1, timeOccurrence.realDeparture1,
      timeOccurrence.realEntry2, timeOccurrence.realDeparture2,
      timeOccurrence.realEntry3, timeOccurrence.realDeparture3,
      timeOccurrence.realEntry4, timeOccurrence.realDeparture4
    ];

    return !realTimes.includes(time);
  }

  openManagementRegistrations(timeOccurrence: TimeOccurrenceModel) {
    const modalRef = this._modalService.open(
      ManageRegistrationsModalComponent, {
      windowClass: "phs-modal",
      backdropClass: "phs-modal-backdrop"

    });
    modalRef.componentInstance.timeOccurrence = timeOccurrence;
    modalRef.closed.pipe(takeUntil(this.destroy$)).subscribe((submit) => {
      if (submit) {
        console.log("Registrations managed successfully");
      }
    });
  }

  formatHoursGroup(hours: any[]): string[] {
    return hours.map(h => this.formatToHourAndMinutes(h));
  }

  getRealHours(item: any): string[] {
    return this.formatHoursGroup([
      item.realEntry1, item.realDeparture1,
      item.realEntry2, item.realDeparture2,
      item.realEntry3, item.realDeparture3,
      item.realEntry4, item.realDeparture4
    ]);
  }

  getModifiedHours(item: any): { value: string, modified: boolean }[] {
    const hours = [
      item.modifiedEntry1, item.modifiedDeparture1,
      item.modifiedEntry2, item.modifiedDeparture2,
      item.modifiedEntry3, item.modifiedDeparture3,
      item.modifiedEntry4, item.modifiedDeparture4
    ];
    return hours.map(h => ({
      value: this.formatToHourAndMinutes(h),
      modified: this.isModified(item, h)
    }));
  }

  get showDocumentInHistory(): boolean {
    return (
      this.managedOccurrences?.[0]?.allowedBonusReasons?.some(
        (reason) => reason.requiresDocument === true
      ) ?? false
    );
  }

  getOvertimeHistoryLabel(timeOccurrence: TimeOccurrenceModel): string {
    return this.usesOvertimeJustification
      ? this.getSelectedBonusReasonTitle(timeOccurrence)
      : this.getAuthorizedLabel(timeOccurrence.authorized);
  }

  getOvertimeApprovalReasonLabel(timeOccurrence: TimeOccurrenceModel): string {
    return this.normalizeOvertimeApprovalReason(timeOccurrence.overtimeApprovalReason) ?? "-";
  }

  getOvertimeApprovalReasonPlaceholder(timeOccurrence: TimeOccurrenceModel): string {
    if (timeOccurrence.authorized === true) {
      return "Descreva a necessidade que motivou a hora extra";
    }
    if (timeOccurrence.authorized === false) {
      return "Descreva o motivo da não autorização";
    }
    return "Informe a justificativa da decisão (autorizar/recusar)";
  }

  private normalizeOvertimeApprovalReason(value: string | null | undefined): string | null {
    const normalized = value?.trim();
    return normalized ? normalized : null;
  }

  filterBonusReasons(item: TimeOccurrenceModel): void {
    const searchText = this.filterText.toLowerCase();
    const reasons = (item.allowedBonusReasons ?? []).filter((reason: TimeBonusReasonModel) =>
      reason.title.toLowerCase().includes(searchText)
    );

    if (item.subType === "OVERTIME" && this.usesOvertimeJustification) {
      const synthetic = {
        order: 0,
        title: this.notAuthorizedOptions.label,
        id: guidEmpty,
      } as TimeBonusReasonModel;
      const showSynthetic =
        !searchText || this.notAuthorizedOptions.label.toLowerCase().includes(searchText);
      this.filteredBonusReasons = showSynthetic ? [synthetic, ...reasons] : reasons;
      return;
    }

    this.filteredBonusReasons = reasons;
  }

  isPreAbonoAbsence(item: ExcusedAbsenceModel): boolean {
    return item?.qualificationType == ExcusedAbsenceQualificationType.PreAbono.id.toString()
      || item?.qualificationType == ExcusedAbsenceQualificationType.PreAbono.value.toString();
  }

  getAbsenceReasonLabel(item: ExcusedAbsenceModel): string {
    if (this.isPreAbonoAbsence(item)) {
      return item.bonusReasonDescription || 'Pré-Abono';
    }
    return item.absenceTypeDescription;
  }

  isExcusedAbsenceReproved(item: ExcusedAbsenceModel): boolean {
    return item?.status === 'REPROVED' || item?.status === 2;
  }

}
